import React, { useState, useEffect } from "react";
import { Toggle } from "../../../../_metronic/partials/layout/explore/Toggle";
import { CollaboratorForm } from "./CollaboratorForm";

type Props = {
  id: string;
};

const ViewAddEdit: React.FC<Props> = ({ id }) => {
  const [showHistory, setShowHistory] = useState<boolean>(true);

  useEffect(() => {
    const historyMode = localStorage.getItem("isOpenHistory") || "";
    setShowHistory(historyMode ? JSON.parse(historyMode) : true);
  }, []);

  return (
    <>
      <div className="d-flex flex-column flex-xl-row">
        <div className="flex-lg-row-fluid ">
          <div className="mb-6 mb-xl-9">
            <div className="">
              <CollaboratorForm
                id_row={parseInt(id)}
              />
            </div>
          </div>
        </div>
        {!showHistory && Number(id) > 0 && (
          <Toggle
            onShow={() => {
              setShowHistory(!showHistory);
              const boolean = !showHistory;
              localStorage.setItem("isOpenHistory", boolean.toString());
            }}
          />
        )}
      </div>
    </>
  );
};

export { ViewAddEdit };
